import { jsx as _jsx } from "react/jsx-runtime";
// Importing components
import { CaptionSelection } from '../../../components/player/captions/selection';
import { IconButton } from '../../core/icon-button';
// Importing hooks
import { useShallow } from 'zustand/react/shallow';
// Importing icons
import CaptionsIcon from '@mui/icons-material/SubtitlesRounded';
// Importing store
import { useMediaStore } from '../../../store/media.store';
import { usePlayerStore } from '../../../store/player.store';
// ----------------------------------------------------------------------
export const CaptionControls = () => {
    // Initializing media store
    const { media } = useMediaStore(useShallow((state) => ({
        media: state.media,
    })));
    // Initializing player store
    const { captions } = usePlayerStore(useShallow((state) => ({
        captions: state.captions,
        setCaptions: state.setCaptions,
    })));
    return (_jsx(CaptionSelection, { children: _jsx(IconButton, { "aria-label": "subtitles", sx: {
                backgroundColor: captions && captions !== 'undefined' ? 'primary.main' : 'none',
            }, children: media && media.captions.length > 0 && _jsx(CaptionsIcon, {}) }) }));
};
